'use strict';
var $ = require('jquery');
var jqueryFormMask = require('jquery-mask-plugin');


function init() {
	/* $('form input[type="tel"]').mask('(000) 000-0000', {
		placeholder: '(123) 456-7890'
	}); */

	/* $('form input[type="text"].money').mask("#,##0.00", {
		reverse: true,
		placeholder: '$'
	}); */

	$('form input[type="text"].date').mask("00/00/0000", {
		placeholder: 'MM/DD/YYYY'
	});

	/* $('form input[type="text"].percent').mask("N", {
		translation: {
			N:{pattern: /[0-9\.]/, recursive: true}
		},
		reverse: true,
		placeholder: '%'
	}); */

	/* $('form input[type="text"].year').mask("#,##0", {
		reverse: true
	}); */
}

module.exports = {
	init: init
};